// extracted by mini-css-extract-plugin
export default {"container":"FlashMessages_container__JP5w4","message":"FlashMessages_message__lgiV8","success":"FlashMessages_success__MVz53","failure":"FlashMessages_failure__v6dqE"};